/**
 * portfolio-roll
 */

import Page from '~/page/page';
import Slider from '~/slider/slider';

export default class PortfolioRoll extends Slider {
  init() {
    const elements = {
      slider: '.js-portfolio-roll-slides',
      prev: '.js-portfolio-roll-prev',
      next: '.js-portfolio-roll-next'
    };

    const options = {
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 978,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    this.set(elements, options);
  }
}

Page.mount(PortfolioRoll, '.js-portfolio-roll');
